import { createBrowserRouter } from "react-router-dom";
import { ENTRY, PROFILE, LANDING, LEADERBOARD } from "./constants/urls";
import AppErrorBoundary from "app-error-boundary";
import authRoutes from "modules/auth/auth-routes";
import landingRoutes from "modules/landing/landing-routes";
import customerRewardsRoutes from "modules/rewards/rewards-routes";
import { REWARD } from "./constants/urls";
import leaderboardRoutes from "modules/leaderboard/leaderboard-routes";
import profileRoutes from "modules/profile/profile-routes";


const router = createBrowserRouter(
  [
    {
      path: ENTRY,
      lazy: () => import("./app"),
      ErrorBoundary: AppErrorBoundary,
      children: [
        {
          lazy: () => import("./app-public"),
          children: [
            {
              path: ENTRY,
              lazy: () => import("modules/authQr-status/pages/authQr-status"),
            },
            {
              lazy: () => import("modules/auth/auth"),
              children: authRoutes,
            },
          ],
        },
        {
          lazy: () => import("./app-protected"),
          children: [
            {
              path: LANDING,
              lazy: () => import("./modules/landing/landing"),
              children: landingRoutes
            },
            {
              path: LEADERBOARD,
              lazy: () => import("./modules/leaderboard/leaderboard"),
              children: leaderboardRoutes
            },
            {
              path: PROFILE,
              lazy: () => import("./modules/profile/profile"),
              children: profileRoutes
            },
            {
              path: REWARD,
              lazy: async () => {
                const { default: Rewards } = await import("./modules/rewards/rewards");
                return { Component: Rewards };
              },
              children: customerRewardsRoutes
            },

          ],
        },
      ],
    },
  ],
  // { basename: "/shop" },
);

export default router;
